import { render, staticRenderFns } from "./DrugsTemplates.vue?vue&type=template&id=5b2652bc"
import script from "./DrugsTemplates.vue?vue&type=script&lang=js"
export * from "./DrugsTemplates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports